import {createLazyLoadTrigger} from "@/laraberg_frontend/general"

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNewPackagesGrid)
} else {
    initNewPackagesGrid()
}

function initNewPackagesGrid() {
    const newPackagesGrids = document.querySelectorAll(".wp-block-tutkit-new-packages-grid")
    if (!newPackagesGrids.length) return

    function isScreenWidthValid() {
        return window.innerWidth <= 1118
    }

    async function renderPackagesGrid(item) {
        const {default: axios} = await import("@/app/axios.ts")
        const response = await axios.get(`/${window.translationsData.global_route.locale}/package/get-newest-packages-grid`)
        const packagesList = response.data

        let newestPackagesHTML = ""

        for (const el of packagesList) {
            let type = "normal"
            let typeText = ""

            const t = window.translationsData.translations

            if (Math.ceil((Date.now() - Date.parse(el.locale.first_published_at)) / (1000 * 3600 * 24)) < 11) {
                type = "neu"
                typeText = t.frontend.badge_new
            } else if (
                el.is_public_update &&
                el.public_updated_at &&
                Math.ceil((Date.now() - Date.parse(el.public_updated_at)) / (1000 * 3600 * 24)) < 11
            ) {
                type = "update"
                typeText = t.frontend.badge_update
            }

            newestPackagesHTML += await renderGridItem(el, type, typeText)
            item.querySelector(".new-packages-grid-container").innerHTML = newestPackagesHTML
        }

        hideTestBtn()
        hideModelBtn()
    }

    async function renderGridItem(el, type, typeText) {
        const t = window.translationsData.translations
        let imageTitle = el.image_featured?.title || ""
        let imageAlt = el.image_featured?.alt || ""
        let imageUrl = el.image_featured?.url || ""

        const cardIcons = renderCardIcons(el)

        return `
      <li class="swiper-slide">
        <div class="card in-view">
          <span class="slide-badge ${type}">${typeText}</span>
          <div class="card-head">
            <div class="card-img pointer">
              <picture class="cover">
                <source type="image/avif" srcset=${imageUrl.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i, ".avif")} />
                <img alt="${imageAlt}" title="${imageTitle}" loading="lazy" src=${imageUrl.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|avif)$/i, ".webp")} />
              </picture>
            </div>
            <div class="card-green-overlay">
              <div class="card-green-overlay__button">${t.buttons.to_content} <a href="/${window.translationsData.global_route.locale}/${window.translationsData.translations.routes.packages}/${el.locale.package_id}-${el.locale.slug}" class="link-to-click">${t.frontend.to} ${el.locale.title}</a></div>
            </div>
          </div>
          <div class="card-body">
            <div class="card-title clamp" style="overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; display: -webkit-box; -webkit-line-clamp: 2;">${el.locale.title}</div>
            <p class="clamp" style="overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; display: -webkit-box; -webkit-line-clamp: 1;">${el.locale.subtitle}</p>
          </div>
          <div class="card-footer">
            <div class="card-icons">
              <div></div>
              ${cardIcons}
            </div>
          </div>
        </div>
      </li>`
    }

    async function initSwiper() {
        if (!isScreenWidthValid()) return

        const [{default: Swiper}, {Navigation}] = await Promise.all([
            import("swiper"),
            import("swiper/modules")
        ])

        Swiper.use([Navigation])

        let newPackagesGridMobile

        function handleSwiperSlider() {
            if (window.matchMedia("(max-width: 991px)").matches) {
                newPackagesGridMobile = new Swiper(".new-packages-grid-container-mobile-slider", {
                    slidesPerView: "auto",
                    speed: 600
                })
            } else if (newPackagesGridMobile) {
                newPackagesGridMobile.destroy()
            }
        }

        handleSwiperSlider()
        window.onresize = handleSwiperSlider
    }

    function initializeSection() {
        newPackagesGrids.forEach((item) => {
            renderPackagesGrid(item)

            if (isScreenWidthValid()) {
                initSwiper()
            }
        })
    }

    createLazyLoadTrigger(".wp-block-tutkit-new-packages-grid", 200, initializeSection)

    window.addEventListener("resize", () => {
        if (isScreenWidthValid()) {
            createLazyLoadTrigger(".wp-block-tutkit-new-packages-grid", 200, initSwiper)
        }
    })

    function hideTestBtn() {
        const testButton = document.querySelectorAll(".hidden-if-logged-in")
        const userLoggedIn = document.querySelector("body").classList.contains("logged-in")
        if (testButton.length && !userLoggedIn) {
            testButton.forEach((el) => (el.style.display = "block"))
        }
    }

    async function hideModelBtn() {
        const {default: axios} = await import("@/app/axios.ts")
        const modelButton = document.querySelectorAll(".hidden-if-starter-business-premium")
        const models = await axios.get("/getuserlicense")
        const userLicence = models.data.license
        if (modelButton.length && !(userLicence === "Starter" || userLicence === "Premium" || "Business")) {
            modelButton.forEach((el) => (el.style.display = "flex"))
        }
    }

    function renderCardIcons(el) {
        const t = window.translationsData.translations
        if (el.video_length) {
            let iconsHtml = "<span class=\"icon-label\">"

            if (el.video_length >= 3600 && el.video_length < 7200) {
                iconsHtml += "1 " + t.content.hour + " "
            } else if (el.video_length >= 7200) {
                iconsHtml += Math.floor(el.video_length / 3600) + " " + t.content.hours + " "
            }

            const minutes = Math.round(el.video_length / 60) % 60
            if (minutes === 1) {
                iconsHtml += "1 " + t.content.minute
            } else if (minutes > 1) {
                iconsHtml += minutes + " " + t.content.minutes
            }

            iconsHtml += "</span>"
            return iconsHtml
        } else if (el.page_count) {
            return `<span class="icon-label">${el.page_count} ${el.page_count === 1 ? t.content.page : t.content.pages}</span>`
        } else if (el.asset_count) {
            return `<span class="icon-label">${el.asset_count} ${el.asset_count === 1 ? t.content.content : t.content.contents}</span>`
        }
    }
}
